import { default as apiServicesyHmdfXTLfuMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/apiServices.vue?macro=true";
import { default as _91slug_93VIQZUGzbwhMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/[slug].vue?macro=true";
import { default as indexGH4NBVE2QUMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/index.vue?macro=true";
import { default as indexDUzG0HLzhJMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/index.vue?macro=true";
import { default as MagicTigerImageAPIDocument7jW2DKWU4kMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/MagicTigerImageAPIDocument.vue?macro=true";
import { default as master_centerwgB7JdRZ4WMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/master_center.vue?macro=true";
import { default as index6BnEv4AvUHMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/mobile/index.vue?macro=true";
import { default as orderkMv88iHVrwMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/order.vue?macro=true";
import { default as _91funcType_93Tg4n469Es4Meta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/[funcType].vue?macro=true";
import { default as _91funcType_93cpxtTkoCuFMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/enhance/[funcType].vue?macro=true";
import { default as privacypolicyQ0y5aGDZEqMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/privacypolicy.vue?macro=true";
import { default as termsofuseNr7icHg12CMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/termsofuse.vue?macro=true";
import { default as _91tag_93ytfqC5n6bfMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/[tag].vue?macro=true";
import { default as indexK0OzsxCfA4Meta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/index.vue?macro=true";
import { default as searchPxboz49WLDMeta } from "/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/search.vue?macro=true";
export default [
  {
    name: apiServicesyHmdfXTLfuMeta?.name ?? "apiServices___en",
    path: apiServicesyHmdfXTLfuMeta?.path ?? "/apiServices",
    meta: apiServicesyHmdfXTLfuMeta || {},
    alias: apiServicesyHmdfXTLfuMeta?.alias || [],
    redirect: apiServicesyHmdfXTLfuMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/apiServices.vue").then(m => m.default || m)
  },
  {
    name: apiServicesyHmdfXTLfuMeta?.name ?? "apiServices___ja",
    path: apiServicesyHmdfXTLfuMeta?.path ?? "/ja/apiServices",
    meta: apiServicesyHmdfXTLfuMeta || {},
    alias: apiServicesyHmdfXTLfuMeta?.alias || [],
    redirect: apiServicesyHmdfXTLfuMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/apiServices.vue").then(m => m.default || m)
  },
  {
    name: apiServicesyHmdfXTLfuMeta?.name ?? "apiServices___zh",
    path: apiServicesyHmdfXTLfuMeta?.path ?? "/zh/apiServices",
    meta: apiServicesyHmdfXTLfuMeta || {},
    alias: apiServicesyHmdfXTLfuMeta?.alias || [],
    redirect: apiServicesyHmdfXTLfuMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/apiServices.vue").then(m => m.default || m)
  },
  {
    name: apiServicesyHmdfXTLfuMeta?.name ?? "apiServices___zh-hant",
    path: apiServicesyHmdfXTLfuMeta?.path ?? "/zh-hant/apiServices",
    meta: apiServicesyHmdfXTLfuMeta || {},
    alias: apiServicesyHmdfXTLfuMeta?.alias || [],
    redirect: apiServicesyHmdfXTLfuMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/apiServices.vue").then(m => m.default || m)
  },
  {
    name: apiServicesyHmdfXTLfuMeta?.name ?? "apiServices___es",
    path: apiServicesyHmdfXTLfuMeta?.path ?? "/es/apiServices",
    meta: apiServicesyHmdfXTLfuMeta || {},
    alias: apiServicesyHmdfXTLfuMeta?.alias || [],
    redirect: apiServicesyHmdfXTLfuMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/apiServices.vue").then(m => m.default || m)
  },
  {
    name: apiServicesyHmdfXTLfuMeta?.name ?? "apiServices___de",
    path: apiServicesyHmdfXTLfuMeta?.path ?? "/de/apiServices",
    meta: apiServicesyHmdfXTLfuMeta || {},
    alias: apiServicesyHmdfXTLfuMeta?.alias || [],
    redirect: apiServicesyHmdfXTLfuMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/apiServices.vue").then(m => m.default || m)
  },
  {
    name: apiServicesyHmdfXTLfuMeta?.name ?? "apiServices___fr",
    path: apiServicesyHmdfXTLfuMeta?.path ?? "/fr/apiServices",
    meta: apiServicesyHmdfXTLfuMeta || {},
    alias: apiServicesyHmdfXTLfuMeta?.alias || [],
    redirect: apiServicesyHmdfXTLfuMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/apiServices.vue").then(m => m.default || m)
  },
  {
    name: apiServicesyHmdfXTLfuMeta?.name ?? "apiServices___ru",
    path: apiServicesyHmdfXTLfuMeta?.path ?? "/ru/apiServices",
    meta: apiServicesyHmdfXTLfuMeta || {},
    alias: apiServicesyHmdfXTLfuMeta?.alias || [],
    redirect: apiServicesyHmdfXTLfuMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/apiServices.vue").then(m => m.default || m)
  },
  {
    name: apiServicesyHmdfXTLfuMeta?.name ?? "apiServices___pt",
    path: apiServicesyHmdfXTLfuMeta?.path ?? "/pt/apiServices",
    meta: apiServicesyHmdfXTLfuMeta || {},
    alias: apiServicesyHmdfXTLfuMeta?.alias || [],
    redirect: apiServicesyHmdfXTLfuMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/apiServices.vue").then(m => m.default || m)
  },
  {
    name: apiServicesyHmdfXTLfuMeta?.name ?? "apiServices___tr",
    path: apiServicesyHmdfXTLfuMeta?.path ?? "/tr/apiServices",
    meta: apiServicesyHmdfXTLfuMeta || {},
    alias: apiServicesyHmdfXTLfuMeta?.alias || [],
    redirect: apiServicesyHmdfXTLfuMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/apiServices.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VIQZUGzbwhMeta?.name ?? "blog-slug___en",
    path: _91slug_93VIQZUGzbwhMeta?.path ?? "/blog/:slug()",
    meta: _91slug_93VIQZUGzbwhMeta || {},
    alias: _91slug_93VIQZUGzbwhMeta?.alias || [],
    redirect: _91slug_93VIQZUGzbwhMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VIQZUGzbwhMeta?.name ?? "blog-slug___ja",
    path: _91slug_93VIQZUGzbwhMeta?.path ?? "/ja/blog/:slug()",
    meta: _91slug_93VIQZUGzbwhMeta || {},
    alias: _91slug_93VIQZUGzbwhMeta?.alias || [],
    redirect: _91slug_93VIQZUGzbwhMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VIQZUGzbwhMeta?.name ?? "blog-slug___zh",
    path: _91slug_93VIQZUGzbwhMeta?.path ?? "/zh/blog/:slug()",
    meta: _91slug_93VIQZUGzbwhMeta || {},
    alias: _91slug_93VIQZUGzbwhMeta?.alias || [],
    redirect: _91slug_93VIQZUGzbwhMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VIQZUGzbwhMeta?.name ?? "blog-slug___zh-hant",
    path: _91slug_93VIQZUGzbwhMeta?.path ?? "/zh-hant/blog/:slug()",
    meta: _91slug_93VIQZUGzbwhMeta || {},
    alias: _91slug_93VIQZUGzbwhMeta?.alias || [],
    redirect: _91slug_93VIQZUGzbwhMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VIQZUGzbwhMeta?.name ?? "blog-slug___es",
    path: _91slug_93VIQZUGzbwhMeta?.path ?? "/es/blog/:slug()",
    meta: _91slug_93VIQZUGzbwhMeta || {},
    alias: _91slug_93VIQZUGzbwhMeta?.alias || [],
    redirect: _91slug_93VIQZUGzbwhMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VIQZUGzbwhMeta?.name ?? "blog-slug___de",
    path: _91slug_93VIQZUGzbwhMeta?.path ?? "/de/blog/:slug()",
    meta: _91slug_93VIQZUGzbwhMeta || {},
    alias: _91slug_93VIQZUGzbwhMeta?.alias || [],
    redirect: _91slug_93VIQZUGzbwhMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VIQZUGzbwhMeta?.name ?? "blog-slug___fr",
    path: _91slug_93VIQZUGzbwhMeta?.path ?? "/fr/blog/:slug()",
    meta: _91slug_93VIQZUGzbwhMeta || {},
    alias: _91slug_93VIQZUGzbwhMeta?.alias || [],
    redirect: _91slug_93VIQZUGzbwhMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VIQZUGzbwhMeta?.name ?? "blog-slug___ru",
    path: _91slug_93VIQZUGzbwhMeta?.path ?? "/ru/blog/:slug()",
    meta: _91slug_93VIQZUGzbwhMeta || {},
    alias: _91slug_93VIQZUGzbwhMeta?.alias || [],
    redirect: _91slug_93VIQZUGzbwhMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VIQZUGzbwhMeta?.name ?? "blog-slug___pt",
    path: _91slug_93VIQZUGzbwhMeta?.path ?? "/pt/blog/:slug()",
    meta: _91slug_93VIQZUGzbwhMeta || {},
    alias: _91slug_93VIQZUGzbwhMeta?.alias || [],
    redirect: _91slug_93VIQZUGzbwhMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93VIQZUGzbwhMeta?.name ?? "blog-slug___tr",
    path: _91slug_93VIQZUGzbwhMeta?.path ?? "/tr/blog/:slug()",
    meta: _91slug_93VIQZUGzbwhMeta || {},
    alias: _91slug_93VIQZUGzbwhMeta?.alias || [],
    redirect: _91slug_93VIQZUGzbwhMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexGH4NBVE2QUMeta?.name ?? "blog___en",
    path: indexGH4NBVE2QUMeta?.path ?? "/blog",
    meta: indexGH4NBVE2QUMeta || {},
    alias: indexGH4NBVE2QUMeta?.alias || [],
    redirect: indexGH4NBVE2QUMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexGH4NBVE2QUMeta?.name ?? "blog___ja",
    path: indexGH4NBVE2QUMeta?.path ?? "/ja/blog",
    meta: indexGH4NBVE2QUMeta || {},
    alias: indexGH4NBVE2QUMeta?.alias || [],
    redirect: indexGH4NBVE2QUMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexGH4NBVE2QUMeta?.name ?? "blog___zh",
    path: indexGH4NBVE2QUMeta?.path ?? "/zh/blog",
    meta: indexGH4NBVE2QUMeta || {},
    alias: indexGH4NBVE2QUMeta?.alias || [],
    redirect: indexGH4NBVE2QUMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexGH4NBVE2QUMeta?.name ?? "blog___zh-hant",
    path: indexGH4NBVE2QUMeta?.path ?? "/zh-hant/blog",
    meta: indexGH4NBVE2QUMeta || {},
    alias: indexGH4NBVE2QUMeta?.alias || [],
    redirect: indexGH4NBVE2QUMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexGH4NBVE2QUMeta?.name ?? "blog___es",
    path: indexGH4NBVE2QUMeta?.path ?? "/es/blog",
    meta: indexGH4NBVE2QUMeta || {},
    alias: indexGH4NBVE2QUMeta?.alias || [],
    redirect: indexGH4NBVE2QUMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexGH4NBVE2QUMeta?.name ?? "blog___de",
    path: indexGH4NBVE2QUMeta?.path ?? "/de/blog",
    meta: indexGH4NBVE2QUMeta || {},
    alias: indexGH4NBVE2QUMeta?.alias || [],
    redirect: indexGH4NBVE2QUMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexGH4NBVE2QUMeta?.name ?? "blog___fr",
    path: indexGH4NBVE2QUMeta?.path ?? "/fr/blog",
    meta: indexGH4NBVE2QUMeta || {},
    alias: indexGH4NBVE2QUMeta?.alias || [],
    redirect: indexGH4NBVE2QUMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexGH4NBVE2QUMeta?.name ?? "blog___ru",
    path: indexGH4NBVE2QUMeta?.path ?? "/ru/blog",
    meta: indexGH4NBVE2QUMeta || {},
    alias: indexGH4NBVE2QUMeta?.alias || [],
    redirect: indexGH4NBVE2QUMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexGH4NBVE2QUMeta?.name ?? "blog___pt",
    path: indexGH4NBVE2QUMeta?.path ?? "/pt/blog",
    meta: indexGH4NBVE2QUMeta || {},
    alias: indexGH4NBVE2QUMeta?.alias || [],
    redirect: indexGH4NBVE2QUMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexGH4NBVE2QUMeta?.name ?? "blog___tr",
    path: indexGH4NBVE2QUMeta?.path ?? "/tr/blog",
    meta: indexGH4NBVE2QUMeta || {},
    alias: indexGH4NBVE2QUMeta?.alias || [],
    redirect: indexGH4NBVE2QUMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexDUzG0HLzhJMeta?.name ?? "index___en",
    path: indexDUzG0HLzhJMeta?.path ?? "/",
    meta: indexDUzG0HLzhJMeta || {},
    alias: indexDUzG0HLzhJMeta?.alias || [],
    redirect: indexDUzG0HLzhJMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexDUzG0HLzhJMeta?.name ?? "index___ja",
    path: indexDUzG0HLzhJMeta?.path ?? "/ja",
    meta: indexDUzG0HLzhJMeta || {},
    alias: indexDUzG0HLzhJMeta?.alias || [],
    redirect: indexDUzG0HLzhJMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexDUzG0HLzhJMeta?.name ?? "index___zh",
    path: indexDUzG0HLzhJMeta?.path ?? "/zh",
    meta: indexDUzG0HLzhJMeta || {},
    alias: indexDUzG0HLzhJMeta?.alias || [],
    redirect: indexDUzG0HLzhJMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexDUzG0HLzhJMeta?.name ?? "index___zh-hant",
    path: indexDUzG0HLzhJMeta?.path ?? "/zh-hant",
    meta: indexDUzG0HLzhJMeta || {},
    alias: indexDUzG0HLzhJMeta?.alias || [],
    redirect: indexDUzG0HLzhJMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexDUzG0HLzhJMeta?.name ?? "index___es",
    path: indexDUzG0HLzhJMeta?.path ?? "/es",
    meta: indexDUzG0HLzhJMeta || {},
    alias: indexDUzG0HLzhJMeta?.alias || [],
    redirect: indexDUzG0HLzhJMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexDUzG0HLzhJMeta?.name ?? "index___de",
    path: indexDUzG0HLzhJMeta?.path ?? "/de",
    meta: indexDUzG0HLzhJMeta || {},
    alias: indexDUzG0HLzhJMeta?.alias || [],
    redirect: indexDUzG0HLzhJMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexDUzG0HLzhJMeta?.name ?? "index___fr",
    path: indexDUzG0HLzhJMeta?.path ?? "/fr",
    meta: indexDUzG0HLzhJMeta || {},
    alias: indexDUzG0HLzhJMeta?.alias || [],
    redirect: indexDUzG0HLzhJMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexDUzG0HLzhJMeta?.name ?? "index___ru",
    path: indexDUzG0HLzhJMeta?.path ?? "/ru",
    meta: indexDUzG0HLzhJMeta || {},
    alias: indexDUzG0HLzhJMeta?.alias || [],
    redirect: indexDUzG0HLzhJMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexDUzG0HLzhJMeta?.name ?? "index___pt",
    path: indexDUzG0HLzhJMeta?.path ?? "/pt",
    meta: indexDUzG0HLzhJMeta || {},
    alias: indexDUzG0HLzhJMeta?.alias || [],
    redirect: indexDUzG0HLzhJMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexDUzG0HLzhJMeta?.name ?? "index___tr",
    path: indexDUzG0HLzhJMeta?.path ?? "/tr",
    meta: indexDUzG0HLzhJMeta || {},
    alias: indexDUzG0HLzhJMeta?.alias || [],
    redirect: indexDUzG0HLzhJMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/index.vue").then(m => m.default || m)
  },
  {
    name: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.name ?? "MagicTigerImageAPIDocument___en",
    path: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.path ?? "/MagicTigerImageAPIDocument",
    meta: MagicTigerImageAPIDocument7jW2DKWU4kMeta || {},
    alias: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.alias || [],
    redirect: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/MagicTigerImageAPIDocument.vue").then(m => m.default || m)
  },
  {
    name: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.name ?? "MagicTigerImageAPIDocument___ja",
    path: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.path ?? "/ja/MagicTigerImageAPIDocument",
    meta: MagicTigerImageAPIDocument7jW2DKWU4kMeta || {},
    alias: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.alias || [],
    redirect: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/MagicTigerImageAPIDocument.vue").then(m => m.default || m)
  },
  {
    name: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.name ?? "MagicTigerImageAPIDocument___zh",
    path: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.path ?? "/zh/MagicTigerImageAPIDocument",
    meta: MagicTigerImageAPIDocument7jW2DKWU4kMeta || {},
    alias: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.alias || [],
    redirect: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/MagicTigerImageAPIDocument.vue").then(m => m.default || m)
  },
  {
    name: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.name ?? "MagicTigerImageAPIDocument___zh-hant",
    path: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.path ?? "/zh-hant/MagicTigerImageAPIDocument",
    meta: MagicTigerImageAPIDocument7jW2DKWU4kMeta || {},
    alias: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.alias || [],
    redirect: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/MagicTigerImageAPIDocument.vue").then(m => m.default || m)
  },
  {
    name: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.name ?? "MagicTigerImageAPIDocument___es",
    path: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.path ?? "/es/MagicTigerImageAPIDocument",
    meta: MagicTigerImageAPIDocument7jW2DKWU4kMeta || {},
    alias: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.alias || [],
    redirect: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/MagicTigerImageAPIDocument.vue").then(m => m.default || m)
  },
  {
    name: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.name ?? "MagicTigerImageAPIDocument___de",
    path: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.path ?? "/de/MagicTigerImageAPIDocument",
    meta: MagicTigerImageAPIDocument7jW2DKWU4kMeta || {},
    alias: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.alias || [],
    redirect: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/MagicTigerImageAPIDocument.vue").then(m => m.default || m)
  },
  {
    name: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.name ?? "MagicTigerImageAPIDocument___fr",
    path: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.path ?? "/fr/MagicTigerImageAPIDocument",
    meta: MagicTigerImageAPIDocument7jW2DKWU4kMeta || {},
    alias: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.alias || [],
    redirect: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/MagicTigerImageAPIDocument.vue").then(m => m.default || m)
  },
  {
    name: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.name ?? "MagicTigerImageAPIDocument___ru",
    path: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.path ?? "/ru/MagicTigerImageAPIDocument",
    meta: MagicTigerImageAPIDocument7jW2DKWU4kMeta || {},
    alias: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.alias || [],
    redirect: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/MagicTigerImageAPIDocument.vue").then(m => m.default || m)
  },
  {
    name: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.name ?? "MagicTigerImageAPIDocument___pt",
    path: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.path ?? "/pt/MagicTigerImageAPIDocument",
    meta: MagicTigerImageAPIDocument7jW2DKWU4kMeta || {},
    alias: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.alias || [],
    redirect: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/MagicTigerImageAPIDocument.vue").then(m => m.default || m)
  },
  {
    name: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.name ?? "MagicTigerImageAPIDocument___tr",
    path: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.path ?? "/tr/MagicTigerImageAPIDocument",
    meta: MagicTigerImageAPIDocument7jW2DKWU4kMeta || {},
    alias: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.alias || [],
    redirect: MagicTigerImageAPIDocument7jW2DKWU4kMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/MagicTigerImageAPIDocument.vue").then(m => m.default || m)
  },
  {
    name: master_centerwgB7JdRZ4WMeta?.name ?? "master_center___en",
    path: master_centerwgB7JdRZ4WMeta?.path ?? "/master_center",
    meta: master_centerwgB7JdRZ4WMeta || {},
    alias: master_centerwgB7JdRZ4WMeta?.alias || [],
    redirect: master_centerwgB7JdRZ4WMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/master_center.vue").then(m => m.default || m)
  },
  {
    name: master_centerwgB7JdRZ4WMeta?.name ?? "master_center___ja",
    path: master_centerwgB7JdRZ4WMeta?.path ?? "/ja/master_center",
    meta: master_centerwgB7JdRZ4WMeta || {},
    alias: master_centerwgB7JdRZ4WMeta?.alias || [],
    redirect: master_centerwgB7JdRZ4WMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/master_center.vue").then(m => m.default || m)
  },
  {
    name: master_centerwgB7JdRZ4WMeta?.name ?? "master_center___zh",
    path: master_centerwgB7JdRZ4WMeta?.path ?? "/zh/master_center",
    meta: master_centerwgB7JdRZ4WMeta || {},
    alias: master_centerwgB7JdRZ4WMeta?.alias || [],
    redirect: master_centerwgB7JdRZ4WMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/master_center.vue").then(m => m.default || m)
  },
  {
    name: master_centerwgB7JdRZ4WMeta?.name ?? "master_center___zh-hant",
    path: master_centerwgB7JdRZ4WMeta?.path ?? "/zh-hant/master_center",
    meta: master_centerwgB7JdRZ4WMeta || {},
    alias: master_centerwgB7JdRZ4WMeta?.alias || [],
    redirect: master_centerwgB7JdRZ4WMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/master_center.vue").then(m => m.default || m)
  },
  {
    name: master_centerwgB7JdRZ4WMeta?.name ?? "master_center___es",
    path: master_centerwgB7JdRZ4WMeta?.path ?? "/es/master_center",
    meta: master_centerwgB7JdRZ4WMeta || {},
    alias: master_centerwgB7JdRZ4WMeta?.alias || [],
    redirect: master_centerwgB7JdRZ4WMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/master_center.vue").then(m => m.default || m)
  },
  {
    name: master_centerwgB7JdRZ4WMeta?.name ?? "master_center___de",
    path: master_centerwgB7JdRZ4WMeta?.path ?? "/de/master_center",
    meta: master_centerwgB7JdRZ4WMeta || {},
    alias: master_centerwgB7JdRZ4WMeta?.alias || [],
    redirect: master_centerwgB7JdRZ4WMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/master_center.vue").then(m => m.default || m)
  },
  {
    name: master_centerwgB7JdRZ4WMeta?.name ?? "master_center___fr",
    path: master_centerwgB7JdRZ4WMeta?.path ?? "/fr/master_center",
    meta: master_centerwgB7JdRZ4WMeta || {},
    alias: master_centerwgB7JdRZ4WMeta?.alias || [],
    redirect: master_centerwgB7JdRZ4WMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/master_center.vue").then(m => m.default || m)
  },
  {
    name: master_centerwgB7JdRZ4WMeta?.name ?? "master_center___ru",
    path: master_centerwgB7JdRZ4WMeta?.path ?? "/ru/master_center",
    meta: master_centerwgB7JdRZ4WMeta || {},
    alias: master_centerwgB7JdRZ4WMeta?.alias || [],
    redirect: master_centerwgB7JdRZ4WMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/master_center.vue").then(m => m.default || m)
  },
  {
    name: master_centerwgB7JdRZ4WMeta?.name ?? "master_center___pt",
    path: master_centerwgB7JdRZ4WMeta?.path ?? "/pt/master_center",
    meta: master_centerwgB7JdRZ4WMeta || {},
    alias: master_centerwgB7JdRZ4WMeta?.alias || [],
    redirect: master_centerwgB7JdRZ4WMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/master_center.vue").then(m => m.default || m)
  },
  {
    name: master_centerwgB7JdRZ4WMeta?.name ?? "master_center___tr",
    path: master_centerwgB7JdRZ4WMeta?.path ?? "/tr/master_center",
    meta: master_centerwgB7JdRZ4WMeta || {},
    alias: master_centerwgB7JdRZ4WMeta?.alias || [],
    redirect: master_centerwgB7JdRZ4WMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/master_center.vue").then(m => m.default || m)
  },
  {
    name: index6BnEv4AvUHMeta?.name ?? "mobile___en",
    path: index6BnEv4AvUHMeta?.path ?? "/mobile",
    meta: index6BnEv4AvUHMeta || {},
    alias: index6BnEv4AvUHMeta?.alias || [],
    redirect: index6BnEv4AvUHMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/mobile/index.vue").then(m => m.default || m)
  },
  {
    name: index6BnEv4AvUHMeta?.name ?? "mobile___ja",
    path: index6BnEv4AvUHMeta?.path ?? "/ja/mobile",
    meta: index6BnEv4AvUHMeta || {},
    alias: index6BnEv4AvUHMeta?.alias || [],
    redirect: index6BnEv4AvUHMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/mobile/index.vue").then(m => m.default || m)
  },
  {
    name: index6BnEv4AvUHMeta?.name ?? "mobile___zh",
    path: index6BnEv4AvUHMeta?.path ?? "/zh/mobile",
    meta: index6BnEv4AvUHMeta || {},
    alias: index6BnEv4AvUHMeta?.alias || [],
    redirect: index6BnEv4AvUHMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/mobile/index.vue").then(m => m.default || m)
  },
  {
    name: index6BnEv4AvUHMeta?.name ?? "mobile___zh-hant",
    path: index6BnEv4AvUHMeta?.path ?? "/zh-hant/mobile",
    meta: index6BnEv4AvUHMeta || {},
    alias: index6BnEv4AvUHMeta?.alias || [],
    redirect: index6BnEv4AvUHMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/mobile/index.vue").then(m => m.default || m)
  },
  {
    name: index6BnEv4AvUHMeta?.name ?? "mobile___es",
    path: index6BnEv4AvUHMeta?.path ?? "/es/mobile",
    meta: index6BnEv4AvUHMeta || {},
    alias: index6BnEv4AvUHMeta?.alias || [],
    redirect: index6BnEv4AvUHMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/mobile/index.vue").then(m => m.default || m)
  },
  {
    name: index6BnEv4AvUHMeta?.name ?? "mobile___de",
    path: index6BnEv4AvUHMeta?.path ?? "/de/mobile",
    meta: index6BnEv4AvUHMeta || {},
    alias: index6BnEv4AvUHMeta?.alias || [],
    redirect: index6BnEv4AvUHMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/mobile/index.vue").then(m => m.default || m)
  },
  {
    name: index6BnEv4AvUHMeta?.name ?? "mobile___fr",
    path: index6BnEv4AvUHMeta?.path ?? "/fr/mobile",
    meta: index6BnEv4AvUHMeta || {},
    alias: index6BnEv4AvUHMeta?.alias || [],
    redirect: index6BnEv4AvUHMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/mobile/index.vue").then(m => m.default || m)
  },
  {
    name: index6BnEv4AvUHMeta?.name ?? "mobile___ru",
    path: index6BnEv4AvUHMeta?.path ?? "/ru/mobile",
    meta: index6BnEv4AvUHMeta || {},
    alias: index6BnEv4AvUHMeta?.alias || [],
    redirect: index6BnEv4AvUHMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/mobile/index.vue").then(m => m.default || m)
  },
  {
    name: index6BnEv4AvUHMeta?.name ?? "mobile___pt",
    path: index6BnEv4AvUHMeta?.path ?? "/pt/mobile",
    meta: index6BnEv4AvUHMeta || {},
    alias: index6BnEv4AvUHMeta?.alias || [],
    redirect: index6BnEv4AvUHMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/mobile/index.vue").then(m => m.default || m)
  },
  {
    name: index6BnEv4AvUHMeta?.name ?? "mobile___tr",
    path: index6BnEv4AvUHMeta?.path ?? "/tr/mobile",
    meta: index6BnEv4AvUHMeta || {},
    alias: index6BnEv4AvUHMeta?.alias || [],
    redirect: index6BnEv4AvUHMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/mobile/index.vue").then(m => m.default || m)
  },
  {
    name: orderkMv88iHVrwMeta?.name ?? "order___en",
    path: orderkMv88iHVrwMeta?.path ?? "/order",
    meta: orderkMv88iHVrwMeta || {},
    alias: orderkMv88iHVrwMeta?.alias || [],
    redirect: orderkMv88iHVrwMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/order.vue").then(m => m.default || m)
  },
  {
    name: orderkMv88iHVrwMeta?.name ?? "order___ja",
    path: orderkMv88iHVrwMeta?.path ?? "/ja/order",
    meta: orderkMv88iHVrwMeta || {},
    alias: orderkMv88iHVrwMeta?.alias || [],
    redirect: orderkMv88iHVrwMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/order.vue").then(m => m.default || m)
  },
  {
    name: orderkMv88iHVrwMeta?.name ?? "order___zh",
    path: orderkMv88iHVrwMeta?.path ?? "/zh/order",
    meta: orderkMv88iHVrwMeta || {},
    alias: orderkMv88iHVrwMeta?.alias || [],
    redirect: orderkMv88iHVrwMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/order.vue").then(m => m.default || m)
  },
  {
    name: orderkMv88iHVrwMeta?.name ?? "order___zh-hant",
    path: orderkMv88iHVrwMeta?.path ?? "/zh-hant/order",
    meta: orderkMv88iHVrwMeta || {},
    alias: orderkMv88iHVrwMeta?.alias || [],
    redirect: orderkMv88iHVrwMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/order.vue").then(m => m.default || m)
  },
  {
    name: orderkMv88iHVrwMeta?.name ?? "order___es",
    path: orderkMv88iHVrwMeta?.path ?? "/es/order",
    meta: orderkMv88iHVrwMeta || {},
    alias: orderkMv88iHVrwMeta?.alias || [],
    redirect: orderkMv88iHVrwMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/order.vue").then(m => m.default || m)
  },
  {
    name: orderkMv88iHVrwMeta?.name ?? "order___de",
    path: orderkMv88iHVrwMeta?.path ?? "/de/order",
    meta: orderkMv88iHVrwMeta || {},
    alias: orderkMv88iHVrwMeta?.alias || [],
    redirect: orderkMv88iHVrwMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/order.vue").then(m => m.default || m)
  },
  {
    name: orderkMv88iHVrwMeta?.name ?? "order___fr",
    path: orderkMv88iHVrwMeta?.path ?? "/fr/order",
    meta: orderkMv88iHVrwMeta || {},
    alias: orderkMv88iHVrwMeta?.alias || [],
    redirect: orderkMv88iHVrwMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/order.vue").then(m => m.default || m)
  },
  {
    name: orderkMv88iHVrwMeta?.name ?? "order___ru",
    path: orderkMv88iHVrwMeta?.path ?? "/ru/order",
    meta: orderkMv88iHVrwMeta || {},
    alias: orderkMv88iHVrwMeta?.alias || [],
    redirect: orderkMv88iHVrwMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/order.vue").then(m => m.default || m)
  },
  {
    name: orderkMv88iHVrwMeta?.name ?? "order___pt",
    path: orderkMv88iHVrwMeta?.path ?? "/pt/order",
    meta: orderkMv88iHVrwMeta || {},
    alias: orderkMv88iHVrwMeta?.alias || [],
    redirect: orderkMv88iHVrwMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/order.vue").then(m => m.default || m)
  },
  {
    name: orderkMv88iHVrwMeta?.name ?? "order___tr",
    path: orderkMv88iHVrwMeta?.path ?? "/tr/order",
    meta: orderkMv88iHVrwMeta || {},
    alias: orderkMv88iHVrwMeta?.alias || [],
    redirect: orderkMv88iHVrwMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/order.vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93Tg4n469Es4Meta?.name ?? "picma_web-funcType___en",
    path: _91funcType_93Tg4n469Es4Meta?.path ?? "/picma_web/:funcType()",
    meta: _91funcType_93Tg4n469Es4Meta || {},
    alias: _91funcType_93Tg4n469Es4Meta?.alias || [],
    redirect: _91funcType_93Tg4n469Es4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93Tg4n469Es4Meta?.name ?? "picma_web-funcType___ja",
    path: _91funcType_93Tg4n469Es4Meta?.path ?? "/ja/picma_web/:funcType()",
    meta: _91funcType_93Tg4n469Es4Meta || {},
    alias: _91funcType_93Tg4n469Es4Meta?.alias || [],
    redirect: _91funcType_93Tg4n469Es4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93Tg4n469Es4Meta?.name ?? "picma_web-funcType___zh",
    path: _91funcType_93Tg4n469Es4Meta?.path ?? "/zh/picma_web/:funcType()",
    meta: _91funcType_93Tg4n469Es4Meta || {},
    alias: _91funcType_93Tg4n469Es4Meta?.alias || [],
    redirect: _91funcType_93Tg4n469Es4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93Tg4n469Es4Meta?.name ?? "picma_web-funcType___zh-hant",
    path: _91funcType_93Tg4n469Es4Meta?.path ?? "/zh-hant/picma_web/:funcType()",
    meta: _91funcType_93Tg4n469Es4Meta || {},
    alias: _91funcType_93Tg4n469Es4Meta?.alias || [],
    redirect: _91funcType_93Tg4n469Es4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93Tg4n469Es4Meta?.name ?? "picma_web-funcType___es",
    path: _91funcType_93Tg4n469Es4Meta?.path ?? "/es/picma_web/:funcType()",
    meta: _91funcType_93Tg4n469Es4Meta || {},
    alias: _91funcType_93Tg4n469Es4Meta?.alias || [],
    redirect: _91funcType_93Tg4n469Es4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93Tg4n469Es4Meta?.name ?? "picma_web-funcType___de",
    path: _91funcType_93Tg4n469Es4Meta?.path ?? "/de/picma_web/:funcType()",
    meta: _91funcType_93Tg4n469Es4Meta || {},
    alias: _91funcType_93Tg4n469Es4Meta?.alias || [],
    redirect: _91funcType_93Tg4n469Es4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93Tg4n469Es4Meta?.name ?? "picma_web-funcType___fr",
    path: _91funcType_93Tg4n469Es4Meta?.path ?? "/fr/picma_web/:funcType()",
    meta: _91funcType_93Tg4n469Es4Meta || {},
    alias: _91funcType_93Tg4n469Es4Meta?.alias || [],
    redirect: _91funcType_93Tg4n469Es4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93Tg4n469Es4Meta?.name ?? "picma_web-funcType___ru",
    path: _91funcType_93Tg4n469Es4Meta?.path ?? "/ru/picma_web/:funcType()",
    meta: _91funcType_93Tg4n469Es4Meta || {},
    alias: _91funcType_93Tg4n469Es4Meta?.alias || [],
    redirect: _91funcType_93Tg4n469Es4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93Tg4n469Es4Meta?.name ?? "picma_web-funcType___pt",
    path: _91funcType_93Tg4n469Es4Meta?.path ?? "/pt/picma_web/:funcType()",
    meta: _91funcType_93Tg4n469Es4Meta || {},
    alias: _91funcType_93Tg4n469Es4Meta?.alias || [],
    redirect: _91funcType_93Tg4n469Es4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93Tg4n469Es4Meta?.name ?? "picma_web-funcType___tr",
    path: _91funcType_93Tg4n469Es4Meta?.path ?? "/tr/picma_web/:funcType()",
    meta: _91funcType_93Tg4n469Es4Meta || {},
    alias: _91funcType_93Tg4n469Es4Meta?.alias || [],
    redirect: _91funcType_93Tg4n469Es4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93cpxtTkoCuFMeta?.name ?? "picma_web-enhance-funcType___en",
    path: _91funcType_93cpxtTkoCuFMeta?.path ?? "/picma_web/enhance/:funcType()",
    meta: _91funcType_93cpxtTkoCuFMeta || {},
    alias: _91funcType_93cpxtTkoCuFMeta?.alias || [],
    redirect: _91funcType_93cpxtTkoCuFMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/enhance/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93cpxtTkoCuFMeta?.name ?? "picma_web-enhance-funcType___ja",
    path: _91funcType_93cpxtTkoCuFMeta?.path ?? "/ja/picma_web/enhance/:funcType()",
    meta: _91funcType_93cpxtTkoCuFMeta || {},
    alias: _91funcType_93cpxtTkoCuFMeta?.alias || [],
    redirect: _91funcType_93cpxtTkoCuFMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/enhance/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93cpxtTkoCuFMeta?.name ?? "picma_web-enhance-funcType___zh",
    path: _91funcType_93cpxtTkoCuFMeta?.path ?? "/zh/picma_web/enhance/:funcType()",
    meta: _91funcType_93cpxtTkoCuFMeta || {},
    alias: _91funcType_93cpxtTkoCuFMeta?.alias || [],
    redirect: _91funcType_93cpxtTkoCuFMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/enhance/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93cpxtTkoCuFMeta?.name ?? "picma_web-enhance-funcType___zh-hant",
    path: _91funcType_93cpxtTkoCuFMeta?.path ?? "/zh-hant/picma_web/enhance/:funcType()",
    meta: _91funcType_93cpxtTkoCuFMeta || {},
    alias: _91funcType_93cpxtTkoCuFMeta?.alias || [],
    redirect: _91funcType_93cpxtTkoCuFMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/enhance/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93cpxtTkoCuFMeta?.name ?? "picma_web-enhance-funcType___es",
    path: _91funcType_93cpxtTkoCuFMeta?.path ?? "/es/picma_web/enhance/:funcType()",
    meta: _91funcType_93cpxtTkoCuFMeta || {},
    alias: _91funcType_93cpxtTkoCuFMeta?.alias || [],
    redirect: _91funcType_93cpxtTkoCuFMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/enhance/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93cpxtTkoCuFMeta?.name ?? "picma_web-enhance-funcType___de",
    path: _91funcType_93cpxtTkoCuFMeta?.path ?? "/de/picma_web/enhance/:funcType()",
    meta: _91funcType_93cpxtTkoCuFMeta || {},
    alias: _91funcType_93cpxtTkoCuFMeta?.alias || [],
    redirect: _91funcType_93cpxtTkoCuFMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/enhance/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93cpxtTkoCuFMeta?.name ?? "picma_web-enhance-funcType___fr",
    path: _91funcType_93cpxtTkoCuFMeta?.path ?? "/fr/picma_web/enhance/:funcType()",
    meta: _91funcType_93cpxtTkoCuFMeta || {},
    alias: _91funcType_93cpxtTkoCuFMeta?.alias || [],
    redirect: _91funcType_93cpxtTkoCuFMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/enhance/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93cpxtTkoCuFMeta?.name ?? "picma_web-enhance-funcType___ru",
    path: _91funcType_93cpxtTkoCuFMeta?.path ?? "/ru/picma_web/enhance/:funcType()",
    meta: _91funcType_93cpxtTkoCuFMeta || {},
    alias: _91funcType_93cpxtTkoCuFMeta?.alias || [],
    redirect: _91funcType_93cpxtTkoCuFMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/enhance/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93cpxtTkoCuFMeta?.name ?? "picma_web-enhance-funcType___pt",
    path: _91funcType_93cpxtTkoCuFMeta?.path ?? "/pt/picma_web/enhance/:funcType()",
    meta: _91funcType_93cpxtTkoCuFMeta || {},
    alias: _91funcType_93cpxtTkoCuFMeta?.alias || [],
    redirect: _91funcType_93cpxtTkoCuFMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/enhance/[funcType].vue").then(m => m.default || m)
  },
  {
    name: _91funcType_93cpxtTkoCuFMeta?.name ?? "picma_web-enhance-funcType___tr",
    path: _91funcType_93cpxtTkoCuFMeta?.path ?? "/tr/picma_web/enhance/:funcType()",
    meta: _91funcType_93cpxtTkoCuFMeta || {},
    alias: _91funcType_93cpxtTkoCuFMeta?.alias || [],
    redirect: _91funcType_93cpxtTkoCuFMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/enhance/[funcType].vue").then(m => m.default || m)
  },
  {
    name: privacypolicyQ0y5aGDZEqMeta?.name ?? "picma_web-privacypolicy___en",
    path: privacypolicyQ0y5aGDZEqMeta?.path ?? "/picma_web/privacypolicy",
    meta: privacypolicyQ0y5aGDZEqMeta || {},
    alias: privacypolicyQ0y5aGDZEqMeta?.alias || [],
    redirect: privacypolicyQ0y5aGDZEqMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/privacypolicy.vue").then(m => m.default || m)
  },
  {
    name: privacypolicyQ0y5aGDZEqMeta?.name ?? "picma_web-privacypolicy___ja",
    path: privacypolicyQ0y5aGDZEqMeta?.path ?? "/ja/picma_web/privacypolicy",
    meta: privacypolicyQ0y5aGDZEqMeta || {},
    alias: privacypolicyQ0y5aGDZEqMeta?.alias || [],
    redirect: privacypolicyQ0y5aGDZEqMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/privacypolicy.vue").then(m => m.default || m)
  },
  {
    name: privacypolicyQ0y5aGDZEqMeta?.name ?? "picma_web-privacypolicy___zh",
    path: privacypolicyQ0y5aGDZEqMeta?.path ?? "/zh/picma_web/privacypolicy",
    meta: privacypolicyQ0y5aGDZEqMeta || {},
    alias: privacypolicyQ0y5aGDZEqMeta?.alias || [],
    redirect: privacypolicyQ0y5aGDZEqMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/privacypolicy.vue").then(m => m.default || m)
  },
  {
    name: privacypolicyQ0y5aGDZEqMeta?.name ?? "picma_web-privacypolicy___zh-hant",
    path: privacypolicyQ0y5aGDZEqMeta?.path ?? "/zh-hant/picma_web/privacypolicy",
    meta: privacypolicyQ0y5aGDZEqMeta || {},
    alias: privacypolicyQ0y5aGDZEqMeta?.alias || [],
    redirect: privacypolicyQ0y5aGDZEqMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/privacypolicy.vue").then(m => m.default || m)
  },
  {
    name: privacypolicyQ0y5aGDZEqMeta?.name ?? "picma_web-privacypolicy___es",
    path: privacypolicyQ0y5aGDZEqMeta?.path ?? "/es/picma_web/privacypolicy",
    meta: privacypolicyQ0y5aGDZEqMeta || {},
    alias: privacypolicyQ0y5aGDZEqMeta?.alias || [],
    redirect: privacypolicyQ0y5aGDZEqMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/privacypolicy.vue").then(m => m.default || m)
  },
  {
    name: privacypolicyQ0y5aGDZEqMeta?.name ?? "picma_web-privacypolicy___de",
    path: privacypolicyQ0y5aGDZEqMeta?.path ?? "/de/picma_web/privacypolicy",
    meta: privacypolicyQ0y5aGDZEqMeta || {},
    alias: privacypolicyQ0y5aGDZEqMeta?.alias || [],
    redirect: privacypolicyQ0y5aGDZEqMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/privacypolicy.vue").then(m => m.default || m)
  },
  {
    name: privacypolicyQ0y5aGDZEqMeta?.name ?? "picma_web-privacypolicy___fr",
    path: privacypolicyQ0y5aGDZEqMeta?.path ?? "/fr/picma_web/privacypolicy",
    meta: privacypolicyQ0y5aGDZEqMeta || {},
    alias: privacypolicyQ0y5aGDZEqMeta?.alias || [],
    redirect: privacypolicyQ0y5aGDZEqMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/privacypolicy.vue").then(m => m.default || m)
  },
  {
    name: privacypolicyQ0y5aGDZEqMeta?.name ?? "picma_web-privacypolicy___ru",
    path: privacypolicyQ0y5aGDZEqMeta?.path ?? "/ru/picma_web/privacypolicy",
    meta: privacypolicyQ0y5aGDZEqMeta || {},
    alias: privacypolicyQ0y5aGDZEqMeta?.alias || [],
    redirect: privacypolicyQ0y5aGDZEqMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/privacypolicy.vue").then(m => m.default || m)
  },
  {
    name: privacypolicyQ0y5aGDZEqMeta?.name ?? "picma_web-privacypolicy___pt",
    path: privacypolicyQ0y5aGDZEqMeta?.path ?? "/pt/picma_web/privacypolicy",
    meta: privacypolicyQ0y5aGDZEqMeta || {},
    alias: privacypolicyQ0y5aGDZEqMeta?.alias || [],
    redirect: privacypolicyQ0y5aGDZEqMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/privacypolicy.vue").then(m => m.default || m)
  },
  {
    name: privacypolicyQ0y5aGDZEqMeta?.name ?? "picma_web-privacypolicy___tr",
    path: privacypolicyQ0y5aGDZEqMeta?.path ?? "/tr/picma_web/privacypolicy",
    meta: privacypolicyQ0y5aGDZEqMeta || {},
    alias: privacypolicyQ0y5aGDZEqMeta?.alias || [],
    redirect: privacypolicyQ0y5aGDZEqMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/privacypolicy.vue").then(m => m.default || m)
  },
  {
    name: termsofuseNr7icHg12CMeta?.name ?? "picma_web-termsofuse___en",
    path: termsofuseNr7icHg12CMeta?.path ?? "/picma_web/termsofuse",
    meta: termsofuseNr7icHg12CMeta || {},
    alias: termsofuseNr7icHg12CMeta?.alias || [],
    redirect: termsofuseNr7icHg12CMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/termsofuse.vue").then(m => m.default || m)
  },
  {
    name: termsofuseNr7icHg12CMeta?.name ?? "picma_web-termsofuse___ja",
    path: termsofuseNr7icHg12CMeta?.path ?? "/ja/picma_web/termsofuse",
    meta: termsofuseNr7icHg12CMeta || {},
    alias: termsofuseNr7icHg12CMeta?.alias || [],
    redirect: termsofuseNr7icHg12CMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/termsofuse.vue").then(m => m.default || m)
  },
  {
    name: termsofuseNr7icHg12CMeta?.name ?? "picma_web-termsofuse___zh",
    path: termsofuseNr7icHg12CMeta?.path ?? "/zh/picma_web/termsofuse",
    meta: termsofuseNr7icHg12CMeta || {},
    alias: termsofuseNr7icHg12CMeta?.alias || [],
    redirect: termsofuseNr7icHg12CMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/termsofuse.vue").then(m => m.default || m)
  },
  {
    name: termsofuseNr7icHg12CMeta?.name ?? "picma_web-termsofuse___zh-hant",
    path: termsofuseNr7icHg12CMeta?.path ?? "/zh-hant/picma_web/termsofuse",
    meta: termsofuseNr7icHg12CMeta || {},
    alias: termsofuseNr7icHg12CMeta?.alias || [],
    redirect: termsofuseNr7icHg12CMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/termsofuse.vue").then(m => m.default || m)
  },
  {
    name: termsofuseNr7icHg12CMeta?.name ?? "picma_web-termsofuse___es",
    path: termsofuseNr7icHg12CMeta?.path ?? "/es/picma_web/termsofuse",
    meta: termsofuseNr7icHg12CMeta || {},
    alias: termsofuseNr7icHg12CMeta?.alias || [],
    redirect: termsofuseNr7icHg12CMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/termsofuse.vue").then(m => m.default || m)
  },
  {
    name: termsofuseNr7icHg12CMeta?.name ?? "picma_web-termsofuse___de",
    path: termsofuseNr7icHg12CMeta?.path ?? "/de/picma_web/termsofuse",
    meta: termsofuseNr7icHg12CMeta || {},
    alias: termsofuseNr7icHg12CMeta?.alias || [],
    redirect: termsofuseNr7icHg12CMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/termsofuse.vue").then(m => m.default || m)
  },
  {
    name: termsofuseNr7icHg12CMeta?.name ?? "picma_web-termsofuse___fr",
    path: termsofuseNr7icHg12CMeta?.path ?? "/fr/picma_web/termsofuse",
    meta: termsofuseNr7icHg12CMeta || {},
    alias: termsofuseNr7icHg12CMeta?.alias || [],
    redirect: termsofuseNr7icHg12CMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/termsofuse.vue").then(m => m.default || m)
  },
  {
    name: termsofuseNr7icHg12CMeta?.name ?? "picma_web-termsofuse___ru",
    path: termsofuseNr7icHg12CMeta?.path ?? "/ru/picma_web/termsofuse",
    meta: termsofuseNr7icHg12CMeta || {},
    alias: termsofuseNr7icHg12CMeta?.alias || [],
    redirect: termsofuseNr7icHg12CMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/termsofuse.vue").then(m => m.default || m)
  },
  {
    name: termsofuseNr7icHg12CMeta?.name ?? "picma_web-termsofuse___pt",
    path: termsofuseNr7icHg12CMeta?.path ?? "/pt/picma_web/termsofuse",
    meta: termsofuseNr7icHg12CMeta || {},
    alias: termsofuseNr7icHg12CMeta?.alias || [],
    redirect: termsofuseNr7icHg12CMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/termsofuse.vue").then(m => m.default || m)
  },
  {
    name: termsofuseNr7icHg12CMeta?.name ?? "picma_web-termsofuse___tr",
    path: termsofuseNr7icHg12CMeta?.path ?? "/tr/picma_web/termsofuse",
    meta: termsofuseNr7icHg12CMeta || {},
    alias: termsofuseNr7icHg12CMeta?.alias || [],
    redirect: termsofuseNr7icHg12CMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/picma_web/termsofuse.vue").then(m => m.default || m)
  },
  {
    name: _91tag_93ytfqC5n6bfMeta?.name ?? "support-tag___en",
    path: _91tag_93ytfqC5n6bfMeta?.path ?? "/support/:tag()",
    meta: _91tag_93ytfqC5n6bfMeta || {},
    alias: _91tag_93ytfqC5n6bfMeta?.alias || [],
    redirect: _91tag_93ytfqC5n6bfMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93ytfqC5n6bfMeta?.name ?? "support-tag___ja",
    path: _91tag_93ytfqC5n6bfMeta?.path ?? "/ja/support/:tag()",
    meta: _91tag_93ytfqC5n6bfMeta || {},
    alias: _91tag_93ytfqC5n6bfMeta?.alias || [],
    redirect: _91tag_93ytfqC5n6bfMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93ytfqC5n6bfMeta?.name ?? "support-tag___zh",
    path: _91tag_93ytfqC5n6bfMeta?.path ?? "/zh/support/:tag()",
    meta: _91tag_93ytfqC5n6bfMeta || {},
    alias: _91tag_93ytfqC5n6bfMeta?.alias || [],
    redirect: _91tag_93ytfqC5n6bfMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93ytfqC5n6bfMeta?.name ?? "support-tag___zh-hant",
    path: _91tag_93ytfqC5n6bfMeta?.path ?? "/zh-hant/support/:tag()",
    meta: _91tag_93ytfqC5n6bfMeta || {},
    alias: _91tag_93ytfqC5n6bfMeta?.alias || [],
    redirect: _91tag_93ytfqC5n6bfMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93ytfqC5n6bfMeta?.name ?? "support-tag___es",
    path: _91tag_93ytfqC5n6bfMeta?.path ?? "/es/support/:tag()",
    meta: _91tag_93ytfqC5n6bfMeta || {},
    alias: _91tag_93ytfqC5n6bfMeta?.alias || [],
    redirect: _91tag_93ytfqC5n6bfMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93ytfqC5n6bfMeta?.name ?? "support-tag___de",
    path: _91tag_93ytfqC5n6bfMeta?.path ?? "/de/support/:tag()",
    meta: _91tag_93ytfqC5n6bfMeta || {},
    alias: _91tag_93ytfqC5n6bfMeta?.alias || [],
    redirect: _91tag_93ytfqC5n6bfMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93ytfqC5n6bfMeta?.name ?? "support-tag___fr",
    path: _91tag_93ytfqC5n6bfMeta?.path ?? "/fr/support/:tag()",
    meta: _91tag_93ytfqC5n6bfMeta || {},
    alias: _91tag_93ytfqC5n6bfMeta?.alias || [],
    redirect: _91tag_93ytfqC5n6bfMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93ytfqC5n6bfMeta?.name ?? "support-tag___ru",
    path: _91tag_93ytfqC5n6bfMeta?.path ?? "/ru/support/:tag()",
    meta: _91tag_93ytfqC5n6bfMeta || {},
    alias: _91tag_93ytfqC5n6bfMeta?.alias || [],
    redirect: _91tag_93ytfqC5n6bfMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93ytfqC5n6bfMeta?.name ?? "support-tag___pt",
    path: _91tag_93ytfqC5n6bfMeta?.path ?? "/pt/support/:tag()",
    meta: _91tag_93ytfqC5n6bfMeta || {},
    alias: _91tag_93ytfqC5n6bfMeta?.alias || [],
    redirect: _91tag_93ytfqC5n6bfMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93ytfqC5n6bfMeta?.name ?? "support-tag___tr",
    path: _91tag_93ytfqC5n6bfMeta?.path ?? "/tr/support/:tag()",
    meta: _91tag_93ytfqC5n6bfMeta || {},
    alias: _91tag_93ytfqC5n6bfMeta?.alias || [],
    redirect: _91tag_93ytfqC5n6bfMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/[tag].vue").then(m => m.default || m)
  },
  {
    name: indexK0OzsxCfA4Meta?.name ?? "support___en",
    path: indexK0OzsxCfA4Meta?.path ?? "/support",
    meta: indexK0OzsxCfA4Meta || {},
    alias: indexK0OzsxCfA4Meta?.alias || [],
    redirect: indexK0OzsxCfA4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/index.vue").then(m => m.default || m)
  },
  {
    name: indexK0OzsxCfA4Meta?.name ?? "support___ja",
    path: indexK0OzsxCfA4Meta?.path ?? "/ja/support",
    meta: indexK0OzsxCfA4Meta || {},
    alias: indexK0OzsxCfA4Meta?.alias || [],
    redirect: indexK0OzsxCfA4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/index.vue").then(m => m.default || m)
  },
  {
    name: indexK0OzsxCfA4Meta?.name ?? "support___zh",
    path: indexK0OzsxCfA4Meta?.path ?? "/zh/support",
    meta: indexK0OzsxCfA4Meta || {},
    alias: indexK0OzsxCfA4Meta?.alias || [],
    redirect: indexK0OzsxCfA4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/index.vue").then(m => m.default || m)
  },
  {
    name: indexK0OzsxCfA4Meta?.name ?? "support___zh-hant",
    path: indexK0OzsxCfA4Meta?.path ?? "/zh-hant/support",
    meta: indexK0OzsxCfA4Meta || {},
    alias: indexK0OzsxCfA4Meta?.alias || [],
    redirect: indexK0OzsxCfA4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/index.vue").then(m => m.default || m)
  },
  {
    name: indexK0OzsxCfA4Meta?.name ?? "support___es",
    path: indexK0OzsxCfA4Meta?.path ?? "/es/support",
    meta: indexK0OzsxCfA4Meta || {},
    alias: indexK0OzsxCfA4Meta?.alias || [],
    redirect: indexK0OzsxCfA4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/index.vue").then(m => m.default || m)
  },
  {
    name: indexK0OzsxCfA4Meta?.name ?? "support___de",
    path: indexK0OzsxCfA4Meta?.path ?? "/de/support",
    meta: indexK0OzsxCfA4Meta || {},
    alias: indexK0OzsxCfA4Meta?.alias || [],
    redirect: indexK0OzsxCfA4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/index.vue").then(m => m.default || m)
  },
  {
    name: indexK0OzsxCfA4Meta?.name ?? "support___fr",
    path: indexK0OzsxCfA4Meta?.path ?? "/fr/support",
    meta: indexK0OzsxCfA4Meta || {},
    alias: indexK0OzsxCfA4Meta?.alias || [],
    redirect: indexK0OzsxCfA4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/index.vue").then(m => m.default || m)
  },
  {
    name: indexK0OzsxCfA4Meta?.name ?? "support___ru",
    path: indexK0OzsxCfA4Meta?.path ?? "/ru/support",
    meta: indexK0OzsxCfA4Meta || {},
    alias: indexK0OzsxCfA4Meta?.alias || [],
    redirect: indexK0OzsxCfA4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/index.vue").then(m => m.default || m)
  },
  {
    name: indexK0OzsxCfA4Meta?.name ?? "support___pt",
    path: indexK0OzsxCfA4Meta?.path ?? "/pt/support",
    meta: indexK0OzsxCfA4Meta || {},
    alias: indexK0OzsxCfA4Meta?.alias || [],
    redirect: indexK0OzsxCfA4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/index.vue").then(m => m.default || m)
  },
  {
    name: indexK0OzsxCfA4Meta?.name ?? "support___tr",
    path: indexK0OzsxCfA4Meta?.path ?? "/tr/support",
    meta: indexK0OzsxCfA4Meta || {},
    alias: indexK0OzsxCfA4Meta?.alias || [],
    redirect: indexK0OzsxCfA4Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/index.vue").then(m => m.default || m)
  },
  {
    name: searchPxboz49WLDMeta?.name ?? "support-search___en",
    path: searchPxboz49WLDMeta?.path ?? "/support/search",
    meta: searchPxboz49WLDMeta || {},
    alias: searchPxboz49WLDMeta?.alias || [],
    redirect: searchPxboz49WLDMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/search.vue").then(m => m.default || m)
  },
  {
    name: searchPxboz49WLDMeta?.name ?? "support-search___ja",
    path: searchPxboz49WLDMeta?.path ?? "/ja/support/search",
    meta: searchPxboz49WLDMeta || {},
    alias: searchPxboz49WLDMeta?.alias || [],
    redirect: searchPxboz49WLDMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/search.vue").then(m => m.default || m)
  },
  {
    name: searchPxboz49WLDMeta?.name ?? "support-search___zh",
    path: searchPxboz49WLDMeta?.path ?? "/zh/support/search",
    meta: searchPxboz49WLDMeta || {},
    alias: searchPxboz49WLDMeta?.alias || [],
    redirect: searchPxboz49WLDMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/search.vue").then(m => m.default || m)
  },
  {
    name: searchPxboz49WLDMeta?.name ?? "support-search___zh-hant",
    path: searchPxboz49WLDMeta?.path ?? "/zh-hant/support/search",
    meta: searchPxboz49WLDMeta || {},
    alias: searchPxboz49WLDMeta?.alias || [],
    redirect: searchPxboz49WLDMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/search.vue").then(m => m.default || m)
  },
  {
    name: searchPxboz49WLDMeta?.name ?? "support-search___es",
    path: searchPxboz49WLDMeta?.path ?? "/es/support/search",
    meta: searchPxboz49WLDMeta || {},
    alias: searchPxboz49WLDMeta?.alias || [],
    redirect: searchPxboz49WLDMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/search.vue").then(m => m.default || m)
  },
  {
    name: searchPxboz49WLDMeta?.name ?? "support-search___de",
    path: searchPxboz49WLDMeta?.path ?? "/de/support/search",
    meta: searchPxboz49WLDMeta || {},
    alias: searchPxboz49WLDMeta?.alias || [],
    redirect: searchPxboz49WLDMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/search.vue").then(m => m.default || m)
  },
  {
    name: searchPxboz49WLDMeta?.name ?? "support-search___fr",
    path: searchPxboz49WLDMeta?.path ?? "/fr/support/search",
    meta: searchPxboz49WLDMeta || {},
    alias: searchPxboz49WLDMeta?.alias || [],
    redirect: searchPxboz49WLDMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/search.vue").then(m => m.default || m)
  },
  {
    name: searchPxboz49WLDMeta?.name ?? "support-search___ru",
    path: searchPxboz49WLDMeta?.path ?? "/ru/support/search",
    meta: searchPxboz49WLDMeta || {},
    alias: searchPxboz49WLDMeta?.alias || [],
    redirect: searchPxboz49WLDMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/search.vue").then(m => m.default || m)
  },
  {
    name: searchPxboz49WLDMeta?.name ?? "support-search___pt",
    path: searchPxboz49WLDMeta?.path ?? "/pt/support/search",
    meta: searchPxboz49WLDMeta || {},
    alias: searchPxboz49WLDMeta?.alias || [],
    redirect: searchPxboz49WLDMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/search.vue").then(m => m.default || m)
  },
  {
    name: searchPxboz49WLDMeta?.name ?? "support-search___tr",
    path: searchPxboz49WLDMeta?.path ?? "/tr/support/search",
    meta: searchPxboz49WLDMeta || {},
    alias: searchPxboz49WLDMeta?.alias || [],
    redirect: searchPxboz49WLDMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/picmastudio-web-test-2/pages/support/search.vue").then(m => m.default || m)
  }
]